import * as React from "react";
import {Link} from "react-router-dom";
import {PREMIUM_TYPE_ANNUAL, PREMIUM_TYPE_MONTHLY, Renewal} from "@ferry/journey-services";
import {InfoBanner} from "@ferry/portal-core";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";

interface IAutoRenewalInviteBannerProps {
    renewalProposal: Renewal;
    showHideWillBeRenewedConfirmation: (display: boolean) => void;
    setAutomaticRenewal: (a: boolean) => void;
    setPerformRenewal: (a: boolean) => void;
    productWording: React.ReactNode;
    monthlyInstalmentsAllowed: boolean;
    renewalEditUrl: string;
}

interface IAutoRenewalInviteBannerState {
    displayInfoMessage: boolean;
}

export class AutoRenewalInviteBanner extends React.Component<IAutoRenewalInviteBannerProps, IAutoRenewalInviteBannerState> {

    constructor(props: IAutoRenewalInviteBannerProps) {
        super(props);

        this.state = {
            displayInfoMessage: false
        };
    }

    public render() {
        const premiumType: string = this.props.renewalProposal.factors.premiumType;

        return (
            <InfoBanner wording={
                <>
                    <p><strong>You have opted out of auto-renewal.</strong></p>
                    <p>
                        {this.props.productWording}
                    </p>
                    <p>
                        Set up your renewal for{" "}
                        {premiumType === PREMIUM_TYPE_ANNUAL &&
                            <>
                                {getAmountWithDecimalDigits(this.props.renewalProposal.factors.annualPremium)} / year.
                            </>
                        }
                        {premiumType === PREMIUM_TYPE_MONTHLY &&
                            <>
                                {getAmountWithDecimalDigits(this.props.renewalProposal.paymentDetails.instalmentPlan.monthlyPayment)} / month ({getAmountWithDecimalDigits(this.props.renewalProposal.paymentDetails.instalmentPlan.totalAmount)} total).
                            </>
                        }
                    </p>
                    {premiumType === PREMIUM_TYPE_ANNUAL && this.props.monthlyInstalmentsAllowed &&
                        <p>Monthly instalments are available at additional cost.</p>
                    }
                    <div className="row mt-2">
                        <div className="col-12">
                            <div className="mt-2">
                                <button type="button"
                                        className="btn btn-primary mb-0 mt-0 mr-4"
                                        onClick={this.enableAutoRenewal}>Set up your renewal now
                                </button>
                                <Link className="btn btn-text btn-white m-0" to={this.props.renewalEditUrl + this.props.renewalProposal._id}>View / edit renewal</Link>
                            </div>
                        </div>
                    </div>
                </>
            }
            />
        )
    }

    private enableAutoRenewal = (): void => {
        this.props.setAutomaticRenewal(false);
        this.props.setPerformRenewal(true);
        this.props.showHideWillBeRenewedConfirmation(true);
    }

}


